import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { debounce } from 'lodash'
import { isMobile, isTouchDevice } from 'utils/check-device'

import { Badge } from 'gdpp-components/dist/cjs/components/atoms'

import Input from '../Input'
import './style.scss'

const InputDropDown = ({
  fundsList,
  handleInput,
  handleSelect,
  selectedSuffix,
  visitedLabel,
  inputProps,
  extraClasses,
  maxSelected,
  selectedCount,
  size,
  noDataPlaceholder,
  ...restProps
}) => {
  const [dropdownListIsHidden, hideDropdownList] = useState(true)
  const [inputValue, setInputValue] = useState('')
  const [isOnFocus, setFocusStatus] = useState(false)

  const isMaxSelected = () => {
    if (!maxSelected) {
      return false
    }

    // let selectedCount = 0
    // fundsList.forEach((item) => {
    //   if (!item.isVisitedLabel && item.isSelected) {
    //     selectedCount += 1
    //   }
    // })
    return selectedCount >= maxSelected
  }

  const onFocus = () => {
    if (!isMaxSelected()) {
      if (inputValue) {
        handleInput(inputValue)
      }

      setFocusStatus(true)
      hideDropdownList(!fundsList.length)
    }
  }

  const onBlur = () => {
    setFocusStatus(false)
    hideDropdownList(true)
  }

  const onChangeProps =
    isMobile() || isTouchDevice()
      ? {
          onChange: debounce((e) => {
            setInputValue(e.value)
            handleInput(e.value)
          }, 500)
        }
      : {
          onKeyup: debounce((e) => {
            setInputValue(e.value)
            handleInput(e.value)
          }, 500)
        }

  const onSelect = (e, item) => {
    if (item && !item.isSelected) {
      handleSelect({
        shareClassId: item.shareClassId,
        shareClassName: item.shareClassName
      })
      setInputValue('')
      handleInput('')
      setFocusStatus(false)
      hideDropdownList(true)
    }
    e.preventDefault()
  }

  useEffect(() => {
    if (isOnFocus) {
      hideDropdownList(!inputValue && !fundsList.length)
    }
  }, [fundsList])

  return (
    <div className={classnames('fil-input-dropdown', extraClasses)}>
      <Input
        layout=""
        onFocus={onFocus}
        onClick={onFocus}
        value={inputValue}
        size={size}
        onBlur={onBlur}
        {...inputProps}
        {...onChangeProps}
        {...(isMaxSelected() ? { disabled: 'disabled' } : {})}
        {...restProps}
      />
      <div
        className={classnames({
          'fil-input-dropdown__list': true,
          'fil-input-dropdown__list-hide': dropdownListIsHidden
        })}
      >
        {fundsList.length ? (
          !isMaxSelected() &&
          fundsList.map((item) => {
            if (item.isVisitedLabel) {
              return (
                <div
                  className="fil-input-dropdown__list-item fil-input-dropdown__visitedLabel"
                  onMouseDown={(e) => onSelect(e, null)}
                  key="visitedHeader"
                >
                  {visitedLabel}
                </div>
              )
            }
            if (!item.isVisitedLabel && item.isSelected) {
              return (
                <div
                  className="fil-input-dropdown__list-item fil-input-dropdown__list-item__disabled"
                  onMouseDown={(e) => onSelect(e, null)}
                  key={item.shareClassId}
                >
                  <Badge extraClasses="fil-input-dropdown__list-item-badge" color="notification" size="small" label={selectedSuffix} />
                  {item.shareClassName}
                </div>
              )
            }
            return (
              <div className="fil-input-dropdown__list-item" onMouseDown={(e) => onSelect(e, item)} key={item.shareClassId}>
                {item.shareClassName}
              </div>
            )
          })
        ) : (
          <div className="fil-input-dropdown__list-item" onMouseDown={(e) => onSelect(e, null)}>
            {noDataPlaceholder}
          </div>
        )}
      </div>
    </div>
  )
}

InputDropDown.propTypes = {
  handleInput: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  inputProps: PropTypes.object,
  fundsList: PropTypes.array,
  selectedSuffix: PropTypes.string,
  extraClasses: PropTypes.object,
  visitedLabel: PropTypes.string,
  maxSelected: PropTypes.number,
  selectedCount: PropTypes.number,
  size: PropTypes.string,
  noDataPlaceholder: PropTypes.string
}

InputDropDown.defaultProps = {
  fundsList: [],
  selectedSuffix: '',
  visitedLabel: '',
  inputProps: {},
  extraClasses: {},
  maxSelected: null,
  selectedCount: 0,
  size: '',
  noDataPlaceholder: 'No Data'
}

export default InputDropDown
